/* src/app/modules/user/partnersequity/partners/partners-dialog-t.component.css */
/*# sourceMappingURL=partners-dialog-t.component.css.map */
